import React, { useState } from "react";
import { Row, Col, Card, Input, Button, Typography, App, Space } from "antd";
import axios from "axios";
import "./QRText.css";
import HeaderLayout from "../../components/Header";
import FooterLayout from "../../components/Footer";
import PageHeader from "../../components/PageHeader";
import { QRCodeCanvas } from "qrcode.react";

const { Title, Paragraph } = Typography;

const QRText = () => {
  const { notification, message } = App.useApp();
  const [name, setName] = useState("");
  const [text, setText] = useState("");
  const [qrText, setQrText] = useState("");
  const isModule = window.location.pathname.includes("/dashboard/");

  const generateQR = async () => {
    const isModule = window.location.pathname.includes("/dashboard/");
    const authToken = localStorage.getItem("token");
    try {
      const response = await axios.post(
        isModule
          ? `${process.env.REACT_APP_BASE_URL}/api/QR/text-to-qr`
          : `${process.env.REACT_APP_BASE_URL}/api/WebsiteQr/website-text-to-qr`,
        {
          link: "",
          title: name,
          access_source: isModule ? "Private-Web" : "Public-Web",
          qrtext: text,
        },
        {
          headers: isModule
            ? {
                Authorization: `Bearer ${authToken}`,
              }
            : {},
        }
      );
      if (response.data.error === false) {
        setQrText(text);
      }
    } catch (error) {
      message.error("Failed to generate QR code");
    }
  };

  const downloadQR = () => {
    const [canvas] = document.getElementsByTagName("canvas");
    const pngUrl = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.download = "qr-code.png";
    link.href = pngUrl;
    link.click();
  };

  return (
    <>
      {isModule ? <PageHeader /> : <HeaderLayout />}
      <div className="qr-container">
        <Row gutter={24}>
          <Col flex={3}>
            <Card className="qr-card" style={{ height: "100%" }}>
              <Title level={5}>Generate QR</Title>
              <br />
              <div className="form-group">
                <label>Name of your QR code</label>
                <Input
                  placeholder="Enter name of your QR code"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Text Content</label>
                <Input.TextArea
                  rows={5}
                  placeholder="Write your text here"
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                />
              </div>
              <br />
              <Space size={"middle"}>
                <Button type="primary" onClick={generateQR}>
                  Generate QR
                </Button>
                {qrText && (
                  <Button type="primary" onClick={downloadQR}>
                    Download QR
                  </Button>
                )}
              </Space>
            </Card>
          </Col>
          <Col flex={1}>
            <Card className="qr-preview-card">
              {qrText ? (
                <Col align="middle">
                  <QRCodeCanvas value={qrText} size={300} />
                </Col>
              ) : (
                <div className="qr-placeholder" />
              )}
              <Title level={5} style={{ marginTop: 16 }}>
                Generated QR Code
              </Title>
              <Paragraph>
                Your QR code will be displayed here once generated.
              </Paragraph>
            </Card>
          </Col>
        </Row>
      </div>
      {!isModule && <FooterLayout />}
    </>
  );
};

export default QRText;
